import { call, put } from 'redux-saga/effects'

import { handleUnAuthorizedError } from '../../../utils/saga.util'
import { getCategoryDetailSucceed, requestFailure } from '../actions'

export function* getCategoryDetailSaga(
  categoryApi: {
    getCategoryDetail: (...args: any[]) => any
  },
  { payload: categoryId }: { payload: string }
) {
  try {
    const { data } = yield call(categoryApi.getCategoryDetail, categoryId)
    yield put(getCategoryDetailSucceed(data))
  } catch (e) {
    yield handleUnAuthorizedError(e)
    yield put(requestFailure(e))
  }
}
